/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every 20 minutes of screen work, look at something at least 20 feet away for 20 seconds. It's a commonly recommended habit for reducing digital eye strain from prolonged close-up screen focus, not a cure for underlying vision problems.`)
};

const es_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada 20 minutos de trabajo frente a la pantalla, mira algo a al menos 20 pies (6 metros) de distancia durante 20 segundos. Es un hábito comúnmente recomendado para reducir la fatiga visual digital por el enfoque prolongado en pantallas cercanas, no una cura para problemas de visión subyacentes.`)
};

const de_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach jeweils 20 Minuten Bildschirmarbeit 20 Sekunden lang auf etwas mindestens 20 Fuß entfernt schauen. Es ist eine häufig empfohlene Gewohnheit gegen digitale Augenbelastung durch anhaltenden Nahfokus auf den Bildschirm, kein Mittel gegen zugrunde liegende Sehprobleme.`)
};

const nl_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijk elke 20 minuten schermwerk 20 seconden naar iets op minstens 20 voet afstand. Het is een veelaanbevolen gewoonte om digitale oogvermoeidheid door langdurige focus van dichtbij te verminderen, geen remedie voor onderliggende visuele problemen.`)
};

const fr_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les 20 minutes de travail sur écran, regardez quelque chose situé à au moins 6 mètres pendant 20 secondes. C’est une habitude couramment recommandée pour réduire la fatigue oculaire numérique due à une concentration prolongée de près sur un écran, mais pas un remède aux problèmes de vision sous-jacents.`)
};

const it_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni 20 minuti di lavoro al computer, guarda qualcosa ad almeno 6 metri di distanza per 20 secondi. È un'abitudine comunemente consigliata per ridurre l'affaticamento oculare digitale dovuto alla messa a fuoco prolungata da vicino, non una cura per problemi di vista sottostanti.`)
};

const pt_br2_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cada 20 minutos de trabalho com telas, olhe para algo a pelo menos 20 pés (6 metros) de distância por 20 segundos. É um hábito comumente recomendado para reduzir a fadiga ocular digital causada pelo foco prolongado em telas próximas, não uma cura para problemas de visão subjacentes.`)
};

const pt_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cada 20 minutos de trabalho com ecrãs, olhe para algo a pelo menos 20 pés (cerca de 6 metros) de distância durante 20 segundos. É um hábito comummente recomendado para reduzir a fadiga ocular digital causada pelo foco prolongado em ecrãs próximos, não uma cura para problemas de visão subjacentes.`)
};

const ja_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面作業を20分行うごとに、少なくとも20フィート（約6メートル）先のものを20秒間見るというルールです。長時間の近距離での画面凝視によるデジタル眼精疲労を軽減するために広く推奨されている習慣であり、根本的な視力の問題を治すものではありません。`)
};

const zh_timer_u20m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每使用屏幕工作20分钟，就注视至少20英尺外的物体20秒。这是一种常被推荐用来缓解长时间近距离盯屏造成的数字眼疲劳的习惯，但并不能治疗潜在的视力问题。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u20m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u20m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u20m_faq3_a", locale)
	if (locale === "en") return en_timer_u20m_faq3_a(inputs)
	if (locale === "es") return es_timer_u20m_faq3_a(inputs)
	if (locale === "de") return de_timer_u20m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u20m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u20m_faq3_a(inputs)
	if (locale === "it") return it_timer_u20m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u20m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u20m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u20m_faq3_a(inputs)
	return zh_timer_u20m_faq3_a(inputs)
};